/**
 * 残り文字数カウント機能を管理する関数群
 */

// 定数定義
const DEFAULT_MAX_LENGTH = 1000;
const REMAINING_DANGER_THRESHOLD = 100;

const COLOR_DANGER = 'var(--color-error-600)';
const COLOR_DEFAULT = 'var(--color-gray-700)';

/**
 * 残り文字数を計算する関数
 */
function calculateRemainingCharacters(
  inputValue: string,
  maxLength: number = DEFAULT_MAX_LENGTH
): number {
  return Math.max(0, maxLength - inputValue.length);
}

/**
 * 残り文字数に応じた色を取得する関数
 */
function getRemainingCharactersColor(remaining: number): string {
  if (remaining <= REMAINING_DANGER_THRESHOLD) {
    return COLOR_DANGER;
  } else {
    return COLOR_DEFAULT; // gray-700 (デフォルト)
  }
}

/**
 * 残り文字数を更新する関数
 */
export function updateRemainingCharacters(
  inputElement: HTMLTextAreaElement,
  displayElement: HTMLElement,
  maxLength: number = DEFAULT_MAX_LENGTH
): void {
  const remaining = calculateRemainingCharacters(inputElement.value, maxLength);
  displayElement.textContent = remaining.toString();
  displayElement.style.color = getRemainingCharactersColor(remaining);
}
